class Brands {
  constructor(section) {
    if (!section) return;

    this.placeholder = section.querySelector('.brands-list__image-wrapper');
    this.brandList = section.querySelector('.brands-list');
    this.brandLetters = section.querySelector('.brands-letters');
    this.brandLetterLinks = this.brandLetters.querySelectorAll('.slider-item > a[href]');

    if (this.brandList) this.brands = this.brandList.querySelectorAll('.brands-item');

    if (!this.brands.length > 0) return;

    this.init();
  }

  init() {
    const _this = this;
    _this.brands.forEach((brand) => {
      brand.addEventListener('mouseover', _this.onMouseOver.bind(_this));
    });

    _this.brandLetterLinks.forEach((letterLink) => {
      letterLink.addEventListener('click', function (event) {
        event.preventDefault();

        const linkTo = letterLink.getAttribute('href');

        // Make sure the link is meant to go to a div
        if (linkTo.substring(0, 1) != '#') return;

        const letter = linkTo.substring(1);

        const brands = _this.brandList.querySelectorAll(`.brands-item`);
        brands.forEach((brand) => {
          brand.classList.add('is-hidden');
        });

        if (letter == 'All') {
          const brands = _this.brandList.querySelectorAll(`.brands-item`);
          brands.forEach((brand) => {
            brand.classList.remove('is-hidden');
          });
        } else if (letter == '0-9') {
          const allNumbers = '0,1,2,3,4,5,6,7,8,9';
          const numbers = allNumbers.split(',');

          numbers.forEach((number) => {
            const brand = _this.brandList.querySelectorAll(`.brands-item[data-letter="brand-letter-${number}"]`);
            brand.forEach((bra) => {
              bra.classList.remove('is-hidden');
            });
          });
        } else {
          const brandsWithLetter = _this.brandList.querySelectorAll(`.brands-item[data-letter="brand-letter-${letter}"]`);
          brandsWithLetter.forEach((brand) => {
            brand.classList.remove('is-hidden');
          });
        }

        // remove all selected classes
        _this.brandLetterLinks.forEach((link) => {
          link.classList.remove('is-selected');
        });

        // add selected class to current link
        letterLink.classList.add('is-selected');
      });
    });

    window.addEventListener('scroll', function () {
      _this.brandLettersSticky();
    });
  }

  brandLettersSticky() {
    if (!this.brandLetters) return;
    this.brandLetters.classList.toggle('is-sticky', window.scrollY > 0);

    const headerSection = document.querySelector('.shopify-section.header-section');
    headerSection.classList.toggle('not-sticky', window.scrollY > 100);

    const stickyHeader = document.querySelector('.header.is-sticky');
    if (stickyHeader) stickyHeader.classList.toggle('header--shadow-medium', window.scrollY <= 0);
  }

  onMouseOver(event) {
    const brand = event.currentTarget;

    if (this.placeholder) {
      const brandImg = brand.querySelector('.brands-list__image');
      if (brandImg) {
        const clonedbrandImg = brandImg.cloneNode(true);
        clonedbrandImg.setAttribute('class', '');
        clonedbrandImg.classList.add('brands-list__image');
        this.placeholder.innerHTML = clonedbrandImg.outerHTML;
      }
    }
  }
}

const brandsSections = document.querySelectorAll('.shopify-section.section-brands');
if (!brandsSections.length > 0) return;

brandsSections.forEach((brandsSection) => {
  if (brandsSection) {
    new Brands(brandsSection);
  }
});
